import { on } from 'delegated-events';
import showPopup from './modals';
import { DrawSingleCaptcha } from './recaptcha';

let initialized = false;

export default function () {

    if (initialized)
        return;

    initialized = true;

    on('click', '.availability-modal-trigger, .product-availability-trigger', function () {
        const scope = this.closest('[data-scope="addcart"]');

        const requestBody = {

            ProductId: +scope.querySelector('[data-pid]').getAttribute('data-pid'),
            OptionId: +scope.querySelector('[data-optionid]').getAttribute('data-optionid')

        };

        fetch('/availability/popup', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(response => response.text())
            .then(data => {

                showPopup({
                    header: 'Powiadom o dostępności',
                    body: data,
                    overloadClass: 'availability-modal-wrapper'
                });

                //DrawSingleCaptcha(document.querySelector('.goshop-modal .captcha-wrapper'));

            });
    });

    on('click', '#availability-subscribe', function (e) {
        const recaptchaItem = document.querySelector('.goshop-modal .g-recaptcha-response');

        fetch('/api/frontend/availability', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                email: document.querySelector('.goshop-modal .availability-modal-inner input[type="text"]').value,
                recaptcha: recaptchaItem ? recaptchaItem.value : '',
                optionId: document.querySelector('.goshop-modal input#optionId').value
            }),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(response => response.json())
            .then(data => {
                window.currentModalInstance.close();
                showPopup({
                    body: data.message
                });

                if (typeof exponea !== 'undefined') {
                    exponea.track('instock_notification', {
                        customer_ids: {
                            registered: data.email
                        },
                        title: data.title,
                        email: data.email,
                        product_id: data.productId,
                        variant_id: data.variantId,
                        SKU: data.SKU,
                        EAN: data.EAN,
                        product_color: data.Color,
                        price: data.priceGross,

                    });
                    exponea.identify({ 'email_id': data.email });
                }
            })
            .catch(error => {
                console.log(error);
                window.currentModalInstance.close();
            });
    });

}